module.exports = new __parcel__URL__("Klug.5976c746.jpeg").toString();